module.exports = __webpack_public_path__ + "media/wallet-available-banner/book_with_wallet-a962b17f.png";